import { combineReducers } from 'redux';
import formReducer from './form.reducer';
import userReducer from './user.reducer';

export default combineReducers({
  form: formReducer,
  user: userReducer,
});
